import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import LockedPage from './LockedPage';

const PLAN_LEVELS = { starter: 1, pro: 2, enterprise: 3 };

export default function PlanGate({ minPlan, children }) {
  const { user } = useAuth();
  const currentPlan = user?.workspace?.plan || 'starter';
  const currentLevel = PLAN_LEVELS[currentPlan] || 1;
  const requiredLevel = PLAN_LEVELS[minPlan] || 1;

  if (currentLevel < requiredLevel) {
    return <LockedPage requiredPlan={minPlan} currentPlan={currentPlan} />;
  }

  return children;
}
